import { NgModule } from '@angular/core';

import { TestingRootPageModule } from 'pages/testing/testing-root.module';
import { TestWorkoutSolverPageModule } from 'pages/test-workout-solver/test-workout-solver.module';
import { TestNavigationRootPageModule } from 'pages/test-navigation-root/test-navigation-root.module';
import { TestNavigationChildPageModule } from 'pages/test-navigation-child/test-navigation-child.module';
import { TestUiComponentsPageModule } from 'pages/test-ui-components/test-ui-components.module';
import { TestUiToastsPageModule } from 'pages/test-ui-toasts/test-ui-toasts.module';
import { TestUiNutrientsPageModule } from 'pages/test-ui-nutrients/test-ui-nutrients.module';
import { DbSnapshotsPageModule } from 'pages/db-snapshots/db-snapshots.module';
import { DbRestoreJsonPageModule } from 'pages/db-restore-json/db-restore-json.module';

const TESTING_PAGE_MODULES = [
  TestingRootPageModule,
  TestWorkoutSolverPageModule,
  TestNavigationRootPageModule,
  TestNavigationChildPageModule,
  TestUiComponentsPageModule,
  TestUiToastsPageModule,
  TestUiNutrientsPageModule,
  DbSnapshotsPageModule,
  DbRestoreJsonPageModule,
];

/**
 * The internal test and debug screens, reached from the Testing menu.
 *
 * One of the app's per-area page groups: it only groups page modules together,
 * declaring nothing of its own and adding no providers. Why these files exist and
 * what keeps them honest: `design-docs/angular-components.md`, "Creating New
 * Components", step 4.
 */
@NgModule({
  imports: TESTING_PAGE_MODULES,
  exports: TESTING_PAGE_MODULES,
})
export class TestingPagesModule { }
